/* @flow */

import React, {Component} from 'react';
import {connect} from "react-redux";
import cx from "classnames";
import _ from "underscore"
import { t, jt } from "c-3po";

import type {Dashboard} from "platopulse/meta/types/Dashboard";

import HeaderWithBack from "../../components/HeaderWithBack";
import LoadingAndErrorWrapper from "platopulse/components/LoadingAndErrorWrapper";
import SearchHeader from "platopulse/components/SearchHeader";
import EmptyState from "platopulse/components/EmptyState";
import ArchivedItem from "platopulse/components/ArchivedItem";

import {caseInsensitiveSearch} from "platopulse/lib/string"

import type {SetArchivedAction} from "../dashboards";
import {fetchArchivedDashboards, setArchived} from "../dashboards";
import {getArchivedDashboards} from "../selectors";
import {getUserIsAdmin} from "platopulse/selectors/user";

const mapStateToProps = (state, props) => ({
    dashboards: getArchivedDashboards(state),
    isAdmin: getUserIsAdmin(state, props)
});

const mapDispatchToProps = {fetchArchivedDashboards, setArchived};

export class Dashboards extends Component {
    props: {
        dashboards: Dashboard[],
        fetchArchivedDashboards: () => void,
        setArchived: SetArchivedAction,
        isAdmin: boolean
    };

    state = {
        searchText: "",
    }

    componentWillMount() {
        this.props.fetchArchivedDashboards();
    }

    searchTextFilter = (searchText: string) =>
        ({name, description}: Dashboard) =>
            (caseInsensitiveSearch(name, searchText) || (description && caseInsensitiveSearch(description, searchText)))

    getFilteredDashboards = () => {
        const {searchText} = this.state;
        const {dashboards} = this.props;
        const noOpFilter = _.constant(true)

        return _.chain(dashboards)
            .filter(searchText != "" ? this.searchTextFilter(searchText) : noOpFilter)
            .sortBy((dash) => dash.name.toLowerCase())
            .value()
            .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
    }

    render() {
        let {searchText} = this.state;

        const isLoading = this.props.dashboards === null
        const noDashboardsArchived = this.props.dashboards && this.props.dashboards.length === 0
        const filteredDashboards = isLoading ? [] : this.getFilteredDashboards();
        const noSearchResults = searchText !== "" && filteredDashboards.length === 0;

        const headerWithBackContainer =
            <div className="flex align-center pt4 pb1">
                <HeaderWithBack name={t`Archive`}/>
            </div>

        return (
            <LoadingAndErrorWrapper
                loading={isLoading}
                className={cx("relative mx4", {"flex-full ": noDashboardsArchived})}
            >
                { noDashboardsArchived ?
                    <div>
                        {headerWithBackContainer}
                        <div className="full flex justify-center" style={{marginTop: "75px"}}>
                            <EmptyState
                                message={<span>{jt`No dashboards have been ${<br />} archived yet`}</span>}
                                icon="viewArchive"
                            />
                        </div>
                    </div>
                    : <div>
                        {headerWithBackContainer}
                        <div className="flex align-center pb1">
                            <SearchHeader
                                searchText={searchText}
                                setSearchText={(text) => this.setState({searchText: text})}
                            />
                        </div>
                        { noSearchResults ?
                            <div className="flex justify-center">
                                <EmptyState
                                    message={
                                        <div className="mt4">
                                            <h3 className="text-grey-5">{t`No results found`}</h3>
                                            <p className="text-grey-4">{t`Try adjusting your filter to find what you’re looking for.`}</p>
                                        </div>
                                    }
                                    image="/app/img/empty_dashboard"
                                    imageClassName="mln2"
                                    smallDescription
                                />
                            </div>
                            : <div>
                                { filteredDashboards.map((dashboard) =>
                                    <ArchivedItem key={dashboard.id} name={dashboard.name} type="dashboard"
                                                  icon="dashboard"
                                                  isAdmin={true} onUnarchive={async () => {
                                        await this.props.setArchived(dashboard.id, false);
                                    }}/>
                                )}
                            </div>
                        }
                    </div>
                }
            </LoadingAndErrorWrapper>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboards)



// WEBPACK FOOTER //
// ./dashboards/containers/DashboardsArchive.jsx